<template lang="pug">
div
	v-data-table(:items="display_prices" :mobile-breakpoint="0" hide-default-footer disable-pagination)
		template(#header="props")
			thead
				tr
					th.text-left(:title="$t('skipas-price-table:table-header.title')")
						| {{$t('skipas-price-table:table-header')}}
						span.hidden-md-down {{$t('skipas-price-table:table-header.price.high-season')}} {{season}}
					th.text-right(v-for="agegroup in ['adult', 'youth', 'kids']")
						| {{$t(`skipas-price-table:table-header.${agegroup}`)}}
						small.d-block.grey--text(v-if="mergedTable.freeFrom[agegroup].type == 'AGE' && mergedTable.freeFrom[agegroup].value") {{$t('skipas-price-table:price.to_{age}', {age: mergedTable.freeFrom[agegroup].value})}}
						small.d-block.grey--text(v-if="mergedTable.freeFrom[agegroup].type == 'YEAR' && mergedTable.freeFrom[agegroup].value") {{$t('skipas-price-table:price.from_{year}', {year: mergedTable.freeFrom[agegroup].value})}}
		template(#item="{item:price, index}")
			tr
				td.text-left(style="font-weight:600;") {{$tc('skipas-price-table.{count}.days', price.days, { count: price.days })}}
				td.text-right(:title="price[`${field}_item`]?$t('skipas-price-table:price.for.{cluster}', {cluster: price[`${field}_item`] }):null" v-for="field in ['adult', 'youth', 'kids']") {{ $n(price[field], 'currency', $i18n.locale) }}
					span(v-if="price[`${field}_item`]") *
	.caption.grey--text.text--darken-1(v-if="optionList.length")
		ws-icon.mr-1(small) check
		i18n(path="skipas-price-table:.{options}.applicable")
			glue-list(slot="options" glue=", " :lastglue="` ${$t('global.and')} `")
				span(v-for="option in optionList") {{option}}

	.caption.grey--text.text--darken-1(v-if="mergedTable.freeFrom.main.type !== 'NONE' || mergedTable.info")
		ws-icon.mr-1(small) information-circle
		span(v-if="mergedTable.freeFrom.main.type == 'AGE'") {{$t('skipas-price-table:free.from.{age}', {age: mergedTable.freeFrom.main.value})}}
		span(v-if="mergedTable.freeFrom.main.type == 'YEAR'") {{$t('skipas-price-table:free.from.{year}', {year: mergedTable.freeFrom.main.value})}}
		|
		|
		span {{mergedTable.info}}
	.text-center.mb-4(v-if="pdf && destination")
		v-btn.mt-4(color="primary" outlined :href="`${$env.CDN_DOMAIN}${pdf}`" target="_blank") {{$t('skipas-price-table:pdf.button.{destination}', {destination: destination})}}

</template>

<script>
import gql from 'graphql-tag';

export default {
	props: {
		skipas: {
			type: [Object, Array],
			default: null
		},
		destination: {
			type: String,
			required: true
		}
	},
	computed: {
		season() {
			let priceArray;

			if (Array.isArray(this.skipas)) {
				priceArray = this.skipas[0].prices;
			} else {
				priceArray = this.skipas.prices;
			}
			if (!priceArray[0].year) {
				return '';
			}
			return `${priceArray[0].year}/${parseInt(priceArray[0].year) + 1}`;
		},
		mergedTable() {
			if (Array.isArray(this.skipas)) {
				const merged = { ...this.skipas[0] };

				const priceArray = Array(7).fill({ adult: 0, youth: 0, kids: 0 });

				this.skipas.forEach(skipas => {
					skipas.prices.forEach(price => {
						const current = priceArray[price.days - 1];

						['adult', 'youth', 'kids'].forEach(field => {
							if (
								price[field] &&
								(price[field] < current[field] || current[field] === 0)
							)
								priceArray[price.days - 1] = {
									...priceArray[price.days - 1],
									days: price.days,
									[field]: price[field],
									[`${field}_item`]: skipas.name
								};
						});
					});
				});

				merged.prices = priceArray;

				return merged;
			} else {
				return this.skipas;
			}
		},
		pdf() {
			return this.mergedTable.pdf.length ? this.mergedTable.pdf[0].url : false;
		},
		display_prices: function() {
			return this.mergedTable.prices.filter(prices => {
				return prices.youth + prices.adult + prices.kids > 0;
			});
		},
		optionList: function() {
			return Object.keys(this.mergedTable.options).reduce((carry, option, index) => {
				if (this.mergedTable.options[option] === true) {
					let t = this.$t(`skipas-price-table.optionlist.${option.toLowerCase()}`);
					if(index === 0 ) t = t.charAt(0).toUpperCase() + t.slice(1);
					carry.push(t);
				}
				return carry;
			}, []);
		}
	},
	fragments: gql`
		fragment SkipasInfo on Skipasable {
			skipas {
				options {
					hasLowSeasonTarif
					hasFamilyArrangements
					hasStudentDiscount
					hasSeniorDiscount
				}
				info
				currency
				pdf {
					url
				}
				freeFrom {
					main {
						type
						value
					}
					youth {
						type
						value
					}
					adult {
						type
						value
					}
					kids {
						type
						value
					}
				}
				prices(convertToEuro: true) {
					adult
					days
					youth
					kids
					year
				}
			}
		}
	`
};
</script>
